export function isSettingsCategoryVisible(category, access) {
    if (category === 'users_permissions')
        return access.canManageUsers;
    if (category === 'tc_groups') {
        return access.isSuperAdmin || access.isClinicAdmin || access.isTcGroupAdmin;
    }
    // Reporting for a consultant group is only meaningful to that group's
    // members; super admins fan out to every group in the region.
    if (category === 'tc_reporting')
        return access.isSuperAdmin || access.isTcGroupMember;
    return true;
}
/** Falls back to General when the requested category is gated off. */
export function resolveSettingsCategory(category, access) {
    return isSettingsCategoryVisible(category, access) ? category : 'general';
}
